module.exports = __webpack_public_path__ + "assets/img/tree-table.76f687b5.svg";